import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['serviceHistoryDataTable'];

  serviceHistoryDataTableTargetConnected() {
    if (window.$.fn.dataTable.isDataTable('#service-history-table')) {
      window.$('#service-history-table').DataTable().destroy();
    }
    window.$('#service-history-table').DataTable({
      order: [[0, 'desc']],
    });
  }
}
